export function fetchJSON<Type>(url: RequestInfo, init?: RequestInit | undefined): Promise<Type> {
  return fetch(`${url}`, init).then((response) => response.json());
}
